export const ICON_CATEGORY = {
    34 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Agua.svg',
    35 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Educacion.svg',
    36 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Impuestos.svg',
    41 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Energia.svg',
    38 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Obligaciones_Financieras.svg',
    47 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Internet.svg',
    40 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Seguridad_Social.svg',
    42 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Consumo_Masivo.svg',
    43 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Otros.svg',
    44 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Admin_Cojuntos.svg',
    45 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Venta_Catálogo.svg',
    46 : 'https://storage.googleapis.com/puntored_gnx_api_data/public/gas.svg',
    default : 'https://storage.googleapis.com/puntored_gnx_api_data/public/Otros.svg'


}